export type PaginatedOptions = { token?: string };

const getOffsetFromPaginationToken = (token?: string) => {
  if (!token) return 0;

  return parseInt(token, 10);
};

const getPaginationTokenFromOffset = (offset: number) => offset.toString();

export const getPageResults = <T>(array: T[], token: string | undefined, size: number) => {
  const offset = getOffsetFromPaginationToken(token);
  const nextOffset = offset + size;

  const items = array.slice(offset, nextOffset);
  const hasMore = array.length >= nextOffset;
  const nextToken = hasMore ? getPaginationTokenFromOffset(nextOffset) : undefined;

  return { items, hasMore, nextToken };
};
